module.exports = __webpack_public_path__ + "img/pd_C3.8.1 (_Product Drawing_).59e98a7a.png";